// src/services/WlbProfilesService.js
import axios from 'axios'

const WlbProfilesService = {
  // -----------------------------
  // Profiles CRUD
  // -----------------------------
  async list(params = {}) {
    return axios.get('wlb/profiles', { params })
  },

  async get(id, params = {}) {
    return axios.get(`wlb/profiles/${encodeURIComponent(id)}`, { params })
  },

  async create(payload = {}) {
    return axios.post('wlb/profiles', payload)
  },

  async update(id, payload = {}) {
    return axios.put(`wlb/profiles/${encodeURIComponent(id)}`, payload)
  },

  async patch(id, payload = {}) {
    return axios.patch(`wlb/profiles/${encodeURIComponent(id)}`, payload)
  },

  async destroy(id) {
    return axios.delete(`wlb/profiles/${encodeURIComponent(id)}`)
  },

  // -----------------------------
  // Membership (Monitors/Targets)
  // -----------------------------
  // payload: { user_id, role: 'monitor'|'target' }
  async addMember(profileId, payload = {}) {
    return axios.post(`wlb/profiles/${encodeURIComponent(profileId)}/members`, payload)
  },

  // NOTE: axios.delete body must be in config.data
  // payload: { user_id, role: 'monitor'|'target' }
  async removeMember(profileId, payload = {}) {
    return axios.delete(`wlb/profiles/${encodeURIComponent(profileId)}/members`, { data: payload })
  },

  // payload: { role: 'monitor'|'target', user_ids: [] }
  async bulkAdd(profileId, payload = {}) {
    return axios.post(`wlb/profiles/${encodeURIComponent(profileId)}/members/bulk`, payload)
  },

  // Optional: if you later want a bulk remove
  // payload: { role: 'monitor'|'target', user_ids: [] }
  async bulkRemove(profileId, payload = {}) {
    return axios.delete(`wlb/profiles/${encodeURIComponent(profileId)}/members/bulk`, { data: payload })
  },

  // -----------------------------
  // Directory (reuse /users)
  // -----------------------------
  // params example: { per_page: 500, page: 1, status: 'active' }
  async directory(params = {}) {
    return axios.get('users', { params })
  }
}

export default WlbProfilesService
